import {
  PAYMENTS_OUTSTANDING_CLUSTER_PATH,
  PAYMENTS_OUTSTANDING_PATH,
  PAYMENTS_PUBLIC_PATH,
} from '@shared/constants/paths';
import {
  useGetPaymentInfoQuery,
  useGetPublicPaymentInfoQuery,
  useLazyGetPublicReceiptPdfQuery,
  useLazyGetReceiptPdfQuery,
  useSubmitPublicReceiptEmailRequestMutation,
  useSubmitReceiptEmailRequestMutation,
} from '@shared/services/payments';

export const getPaymentReceiptConfig = (isSharedServiceView: boolean) => ({
  public: {
    getPaymentInfoQuery: useGetPublicPaymentInfoQuery,
    getReceiptPdfQuery: useLazyGetPublicReceiptPdfQuery,
    navigateBackURL: PAYMENTS_PUBLIC_PATH,
    sendEmailRequestMutation: useSubmitPublicReceiptEmailRequestMutation,
  },
  singpass: {
    getPaymentInfoQuery: useGetPaymentInfoQuery,
    getReceiptPdfQuery: useLazyGetReceiptPdfQuery,
    navigateBackURL: isSharedServiceView ? PAYMENTS_OUTSTANDING_CLUSTER_PATH : PAYMENTS_OUTSTANDING_PATH,
    sendEmailRequestMutation: useSubmitReceiptEmailRequestMutation,
  },
});
